import React from 'react';

import { NotificationContainer } from 'kissu-react-notifications';
import { Footer, Blog, Possibility, Features, TeamContainer, Whatfgc, Header, Roadmap } from './containers';
import { CTA, Brand, Navbar } from './components';

import './App.css';

const App = () => (
  <div className="App">
    <div className="gradient__bg">
      <Navbar />
      <Header />
    </div>
    <Brand />
    <Possibility />
    <Whatfgc />
    <Roadmap />
    <TeamContainer />
    <Features />
    <CTA />
    <Blog />
    <NotificationContainer />
    <Footer />
  </div>
);

export default App;
